<template>
  <v-container>
    <LoginRequired/>
    <Scanner/>
    <ErrorDialog
        :show="isError"
        :errorContent="errorContent"/>
    <template class="rearrange-palette-container" v-if="isLoaded">
      <template>
        <v-alert
            color="primary"
            elevation="24"
            icon="mdi-information-outline"
            type="info"
        >
          Artikel einlagern
        </v-alert>

        <v-container class="palette-information-container">
          <v-alert
              color="primary"
              elevation="24"
              outlined
              v-model="showStartInfo"
              @click="toggleInfo"
          >
            <v-icon color="primary">mdi-information-outline</v-icon>
            <p>Scannen Sie die Palette ein, die Sie ins Lager einlagern möchten.</p>
            <p>Den Barcode finden Sie auf der linken Seite neben dem EUR Zeichen.</p>
            <p>Alternativ können Sie die Palette auch manuell auswählen.</p>
          </v-alert>
          <v-layout justify-center>
            <v-alert
                color="primary"
                elevation="24"
                outlined
                width="60px"
                v-model="showIconOnly"
                @click="toggleInfo"
            >
              <v-icon color="primary">mdi-information-outline</v-icon>
            </v-alert>
          </v-layout>
        </v-container>

        <v-container class="text-align-center">
          <p>{{ selectedPalette ? selectedPalette.names.displayName : 'Palette wählen' }}</p>
          <v-text-field
              :value="selectedPalette ? selectedPalette.code : ''"
              label="Palette scannen"
              outlined
              ref="scannerResult"
              readonly
              dense
              prepend-icon="mdi-barcode-scan"
              style="margin: auto"
          ></v-text-field>
          <v-btn
              color="blue-grey"
              class="ma-2 white--text"
              :disabled="selectedPalette === null"
              :to="{ name: 'rearrange.warehouse_product.edit_palette', params: {
                binLocationId: this.selectedPalette ? this.selectedPalette.usedIn[0].binLocationId : 0,
                warehouseCodeFrom: this.selectedPalette ? this.selectedPalette.usedIn[0].warehouseCode : 'Unknown',
                paletteName: this.selectedPalette ? this.selectedPalette.names.displayName : 'Palette 0'
              }}"
          >
            <v-icon
                left
                dark
            >
              mdi-cart-arrow-right
            </v-icon>
            Palette<br/>
            verwenden
          </v-btn>
        </v-container>
        <div v-if="warehouseFromObj && warehouseFromObj.palettes && warehouseFromObj.palettes.length > 0">
        <h5>Manuelle Auswahl der Palette</h5>
        <v-virtual-scroll
            :items="warehouseFromObj.palettes"
            :item-height="55"
            :height="200"
            class="palette-scroll"
        >
          <template v-slot:default="{ item }">
            <v-list-item :key="item.code" class="palette-list-item">
              <v-btn
                  @click="selectPalette(item)"
                  block
                  color="secondary"
                  class="white--text palette-button"
                  :disabled="item.isEmpty || (item.usedIn[0].warehouseCode !== 'BhfL' && item.usedIn[0].warehouseCode !== 'L')"
              >
                {{ item.names.displayName }}
                <div v-if="item.isEmpty" class="palette-button-subtitle"> - Leer
                </div>
                <div
                    v-if="!item.isEmpty"
                    class="palette-button-subtitle"> - {{ item.usedIn[0].warehouseName }}
                </div>
              </v-btn>
            </v-list-item>
          </template>
        </v-virtual-scroll>
        </div>
        <div v-else>
          <v-alert
              dense
              outlined
              type="error"
          >
            Keine Paletten gefunden im {{ warehouseFromObj.name }}!
          </v-alert>
        </div>
      </template>
    </template>
    <v-container v-else>
      <v-progress-circular
          indeterminate
          color="primary"
      ></v-progress-circular>
    </v-container>

    <VerticalSpacer/>

  </v-container>
</template>


<script>
import VerticalSpacer from "../../Others/VerticalSpacer";
import LoginRequired from "../../Others/LoginRequired";
import Scanner from "../../Others/Scanner";
import ErrorDialog from "../../Others/ErrorDialog";

export default {
  components: {ErrorDialog, Scanner, LoginRequired, VerticalSpacer},
  data: () => ({
    showStartInfo: false,
    showIconOnly: true,
    selectedPalette: null,
    warehouses: null,
    warehouseFrom: 'BhfL',
    warehouseFromObj: null,
    lagerObj: null,
    bahnhofLagerObj: null,
    isLoaded: false,
    result: null,
    isError: false,
    errorContent: ''
  }),
  created() {
    this.$root.$on('onScannerInput', this.onScannerInputHandler);
    this.$root.$on('onCloseErrorDialog', this.handleCloseErrorDialog);

    this.$axios.get('palette').then(response => {
      if (response && response.data && response.data.data) {
        this.warehouses = response.data.data;
        this.warehouseFromObj = this.warehouses.filter(warehouse => warehouse.code === this.warehouseFrom)[0];
        this.warehouseFromObj.palettes = this.warehouseFromObj.palettes.filter(palette => !palette.isEmpty && (palette.usedIn[0].warehouseCode === 'BhfL' || palette.usedIn[0].warehouseCode === 'L'))
        this.lagerObj = this.warehouses.filter(warehouse => warehouse.code === 'L')[0];
        this.bahnhofLagerObj = this.warehouses.filter(warehouse => warehouse.code === 'BhfL')[0];
        this.isLoaded = true;
      }
    })
  },

  beforeDestroy() {
    this.$root.$off('onScannerInput', this.onScannerInputHandler);
    this.$root.$off('onCloseErrorDialog', this.handleCloseErrorDialog);
  },

  methods: {
    toggleInfo() {
      this.showStartInfo = !this.showStartInfo;
      this.showIconOnly = !this.showIconOnly;
    },
    selectPalette(palette) {
      this.selectedPalette = palette;
    },
    onScannerInputHandler(scannerInputRaw) {
      const scannerInput = this.parseJson(scannerInputRaw);
      const paletteCode = scannerInput.dataAsText.split('$')[1];
      if (!paletteCode) {
        this.selectPalette(null);
        this.$refs.scannerResult.blur();
        return this.setScannerError(`${scannerInput.dataAsText} ist keine gültige Eingabe für Lagerplatz!`);
      }
      const targetPaletteFrom = this.warehouseFromObj.palettes.filter(palette => palette.code === paletteCode)[0];

      if (!targetPaletteFrom) {
        this.selectPalette(null);
        this.$refs.scannerResult.blur();
        return this.setScannerError(`Palette ${paletteCode} kann nicht gefunden werden im Bahnhof Lager!`);
      }

      if (targetPaletteFrom.isEmpty) {
        this.selectPalette(null);
        this.$refs.scannerResult.blur();
        return this.setScannerError(`Palette ${paletteCode} ist leer!`);
      }

      this.selectPalette(targetPaletteFrom);
      this.$refs.scannerResult.blur();
    },

    handleCloseErrorDialog() {
      this.isError = false;
    },

    setScannerError(message) {
      this.isError = true;
      this.errorContent = message;
    },

    parseJson(jsonString) {
      let jsonObj = {
        dataAsText: 'none'
      }
      try {
        jsonObj = JSON.parse(jsonString);
      } catch (e) {
        console.error(e);
      }
      return jsonObj;
    }
  }
}
</script>